import { Database, Upload } from "lucide-react";

interface EmptySessionStateProps {
  onConnectDatabase?: () => void;
  onUploadFiles?: () => void;
}

/**
 * Empty state when no session is active.
 * UX Spec Section 6.5: center-aligned with two CTAs.
 */
export function EmptySessionState({
  onConnectDatabase,
  onUploadFiles,
}: EmptySessionStateProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      {/* Illustration placeholder */}
      <div className="w-24 h-24 rounded-full bg-[var(--primary)]/10 flex items-center justify-center mb-6">
        <Database className="w-10 h-10 text-[var(--primary)]" />
      </div>

      <h2 className="text-heading-2 text-[var(--foreground)] mb-2">
        Connect a data source to begin profiling
      </h2>
      <p className="text-body text-[var(--muted-foreground)] mb-8 max-w-md">
        Upload files or connect a database to discover schema, detect quality
        issues, and define validation rules.
      </p>

      {/* CTAs */}
      <div className="flex flex-col sm:flex-row gap-3">
        <button
          onClick={onConnectDatabase}
          className="flex items-center gap-2 px-6 py-3 rounded-lg bg-[var(--primary)] text-[var(--primary-foreground)] font-semibold hover:opacity-90 transition-opacity"
        >
          <Database className="w-5 h-5" />
          Connect Database
        </button>
        <button
          onClick={onUploadFiles}
          className="flex items-center gap-2 px-6 py-3 rounded-lg border border-[var(--border)] text-[var(--foreground)] font-semibold hover:bg-white/5 transition-colors"
        >
          <Upload className="w-5 h-5" />
          Upload Files
        </button>
      </div>
    </div>
  );
}
